import React, { useEffect, useRef, useState } from 'react';
import { Card, CardBody, CardHeader, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import BreadcrumbTrail from '../../../Common/BreadcrumbTrail';
import { useHistory, useLocation } from 'react-router-dom';
import SLACard from './Components/Card/SLACard';
import moment from 'moment';
import StatusCard from './Components/Card/StatusCard';
import ActionBookingCard from './Components/Card/ActionBookingCard';
import Flatpickr from 'flatpickr';
import Select from 'react-select';
import { DonutChart, GeoChart, Loader } from '../../../Common';
import { useDispatch, useSelector } from 'react-redux';
import { GET_CARD_SUMMARY, GET_CARD_SUMMARY_EMPTY, GET_DASHBOARD_CONFIGURATION, GET_FILTERS_LIST } from '../../../../store/actions';
import queryString from 'query-string';
import classNames from 'classnames';
import StatusPartnerCard from './Components/Card/StatusPartnerCard';
import { Constant } from '../../../Helpers/constant';
import BarChart from '../Dashboard/components/Charts/BarChart';

const initialDate = {
  startDate: '',
  endDate: '',
  timelineFilter: null,
};

const bookingOptions = [
  { value: 'past_bookings', label: 'Past Booking' },
  { value: 'ongoing_bookings', label: 'Ongoing Booking' },
  { value: 'upcoming_bookings', label: 'Upcoming Booking' },
];

interface RootState {
  GetDashboardConfiguration?: {
    data?: any;
    loading?: boolean;
  };
  GetCardSummary?: {
    data?: any;
    loading?: boolean;
  };
  GetFiltersList?: {
    data?: any;
    loading?: boolean;
  };
}

const BookingDashboard = () => {
  const inputRef = useRef(null);
  const flatpickrInstance = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const { nextNavigation, sectionFilter } = queryString.parse(location.search);
  const selectedFilterType = bookingOptions.find(option => option.value === sectionFilter) || null;

  const [filter, setFilter] = useState({ ...initialDate });
  const [filterOfBarChart, setFilterOfBarChart] = useState({ project: null, country: null });
  const [laoding, setLaoding] = useState(false);
  const [slaBooking, setSlaBooking] = useState(null);
  const [statusBooking, setStatusBooking] = useState(null);
  const [actionItemBooking, setActionItemBooking] = useState(null);
  const [partnerBooking, setPartnerBooking] = useState(null);
  const [arrowNavTab, setarrowNavTab] = useState('1');
  const [vendorOptions, setVendorOptions] = useState([]);
  const [selectedVendor, setSelectedSelectedVendor] = useState(null);
  const [charts, setCharts] = useState({
    regionWiseChart: null,
    // projectWiseBookings: null,
    donutChart: null,
    barChart: null,
  });

  const { getDashboardConfiguration, getDashboardConfigurationLoading, cardData, cardDataLoading, filterAPiOptions } = useSelector(
    (state: RootState) => ({
      getDashboardConfiguration: state?.GetDashboardConfiguration?.data,
      getDashboardConfigurationLoading: state?.GetDashboardConfiguration?.loading,

      cardData: state.GetCardSummary.data,
      cardDataLoading: state.GetCardSummary.loading,

      filterAPiOptions: state.GetFiltersList.data,
    }),
  );

  const categorizeBooking = (startDate, endDate) => {
    const today = moment().startOf('day'); // July 9, 00:00

    const start = moment(startDate).startOf('day');
    const end = moment(endDate).endOf('day');

    const upcomingStart = moment(today).add(2, 'days').startOf('day'); // July 11, 00:00
    const pastEnd = moment(today).subtract(3, 'days').endOf('day'); // July 6, 11:59 PM

    const ongoingStart = moment(today).subtract(1, 'days').startOf('day'); // July 8, 00:00
    const ongoingEnd = moment(today).add(1, 'days').endOf('day'); // July 10, 11:59 PM

    if (start.isSameOrAfter(upcomingStart)) {
      return 'upcoming_bookings';
    } else if (end.isSameOrBefore(pastEnd)) {
      return 'past_bookings';
    } else if (start.isSameOrBefore(ongoingEnd) && end.isSameOrAfter(ongoingStart)) {
      return 'ongoing_bookings';
    } else {
      return 'unknown'; // Just in case, for edge cases or misconfigurations
    }
  };

  useEffect(() => {
    setFilter(prev => ({ ...prev, timelineFilter: selectedFilterType }));
  }, [selectedFilterType]);

  useEffect(() => {
    flatpickrInstance.current = Flatpickr(inputRef.current, {
      enableTime: false,
      mode: 'range',
      dateFormat: 'Y-m-d',
      clickOpens: false, // Prevents default click to open
      defaultDate: [initialDate?.startDate, initialDate.endDate],
      onOpen: () => {
        setTimeout(() => {
          const calendarElement = document.querySelector('.flatpickr-calendar') as HTMLElement;

          if (calendarElement) {
            calendarElement.style.top = '4%';
            calendarElement.style.left = '35%';
            calendarElement.style.right = 'auto';
          }
        }, 0); // Ensures the calendar has been rendered before applying styles
      },
      onChange: date => {
        if (date[0] && date[1]) {
          console.log('check', date[0], date[1]);
          const categorizeBookingValue = categorizeBooking(moment(date[0]), moment(date[1]));
          console.log('categorizeBookingValue', categorizeBookingValue);
          updateURLParams(
            bookingOptions.find(bookingType => bookingType.value === categorizeBookingValue),
            false,
          );

          setFilter({
            timelineFilter: null,
            startDate: moment(new Date(date[0])).toISOString(),
            endDate: moment(new Date(date[1])).add(23, 'hours').add(59, 'minutes').add(59, 'seconds').add(999, 'milliseconds')?.toISOString(),
          });
        }
      },
    });
  }, []);

  useEffect(() => {
    if (!filter?.startDate && !filter?.endDate) {
      const currentDate = moment();
      let startDate = '';
      let endDate = '';

      switch (filter.timelineFilter?.value) {
        case 'upcoming_bookings':
          startDate = currentDate.clone().add(2, 'days').startOf('day').toISOString();
          endDate = currentDate.clone().add(30, 'days').endOf('day').toISOString();
          break;

        case 'ongoing_bookings':
          startDate = currentDate.clone().subtract(2, 'days').startOf('day').toISOString();
          endDate = currentDate.clone().add(2, 'days').endOf('day').toISOString();
          break;

        case 'past_bookings':
          startDate = currentDate.clone().subtract(3, 'months').subtract(2, 'days').startOf('day').toISOString();
          endDate = currentDate.clone().subtract(2, 'days').endOf('day').toISOString();
          break;

        default:
          startDate = '';
          endDate = '';
      }
      setFilter(prev => ({ ...prev, startDate, endDate }));
    }
  }, [filter.timelineFilter]);

  useEffect(() => {
    if (getDashboardConfiguration === null) {
      dispatch({
        type: GET_DASHBOARD_CONFIGURATION,
      });
    }

    let bookingType = ``;
    if (`${nextNavigation}`?.includes(`airport`)) {
      bookingType = `airport_transfers`;
    } else if (`${nextNavigation}`?.includes(`golf`)) {
      bookingType = `golf`;
    }

    dispatch({
      type: GET_FILTERS_LIST,
      payload: {
        urlParams: {
          bookingType: bookingType,
        },
      },
    });
  }, []);

  useEffect(() => {
    const userTypes = Number(localStorage.getItem('userType'));
    if (userTypes === Constant.userTypes.VENDOR_USER_V2) {
      history.push('/v2/vendor-dashboard');
    } else if (userTypes === Constant.userTypes.ADMIN_USER) {
      history.push('/login');
    }
  }, []);

  useEffect(() => {
    if (sectionFilter && nextNavigation && getDashboardConfiguration && filter?.startDate && filter?.endDate) {
      fetchAllCards();
    }
  }, [filter, getDashboardConfiguration, selectedVendor, arrowNavTab]);

  useEffect(() => {
    if (filterAPiOptions) {
      const vendorOptions = filterAPiOptions?.results?.[6]?.data?.map(vendor => ({
        value: vendor?.key,
        label: vendor?.value,
      }));
      setVendorOptions(vendorOptions);
      setSelectedSelectedVendor(vendorOptions?.[0]);
    }
  }, [filterAPiOptions]);

  useEffect(() => {
    if (filterOfBarChart?.project || filterOfBarChart?.country) {
      dispatch({
        type: GET_CARD_SUMMARY,
        payload: {
          cards: charts?.barChart ? [charts?.barChart] : [],
          ...(!filter?.timelineFilter && { start_date: filter?.startDate, end_date: filter?.endDate }),
          project: filterOfBarChart?.project ? filterOfBarChart?.project?.value : null,
          country: filterOfBarChart?.country ? filterOfBarChart?.country?.value : null,
        },
      });
    }
  }, [filterOfBarChart]);

  const fetchAllCards = () => {
    const availableSections = getDashboardConfiguration?.modules?.[nextNavigation.toString()]?.sections;
    const defaultSections = availableSections?.filter(card => card.navigationFilter === sectionFilter);
    let totalCards = [];
    const slaBooking = defaultSections?.find(section => section?.priority === 1);
    const statusBooking = defaultSections?.find(section => section?.priority === 2);
    const actionBooking = defaultSections?.find(section => section?.priority === 3);
    const partnerBooking = defaultSections?.find(section => section?.priority === 4);
    const charts = defaultSections?.find(section => section?.priority === 5);

    setSlaBooking(slaBooking);
    setStatusBooking(statusBooking);
    setActionItemBooking(actionBooking);
    setPartnerBooking(partnerBooking);
    if (nextNavigation.toString() === 'airport_transfer_dashboard') {
      setCharts({ regionWiseChart: charts?.cards?.[1], donutChart: charts?.cards?.[0], barChart: null });
    } else {
      setCharts({ regionWiseChart: charts?.cards?.[2], donutChart: charts?.cards?.[1], barChart: charts?.cards?.[0] });
    }

    // Extract cards from SLA and Status Booking
    if (arrowNavTab === '1') {
      totalCards = [...(slaBooking?.cards || []), ...(statusBooking?.cards || []), ...(actionBooking?.cards || []), ...(charts?.cards || [])];
    } else {
      totalCards = [...(partnerBooking?.cards || [])];
    }
    if (totalCards?.length > 0 && ((arrowNavTab === '2' && selectedVendor) || arrowNavTab === '1')) {
      dispatch({
        type: GET_CARD_SUMMARY,
        payload: {
          cards: totalCards,
          ...(!filter?.timelineFilter && { start_date: filter?.startDate, end_date: filter?.endDate }),
          ...(arrowNavTab === '2' && { vendor_id: selectedVendor?.value }),
        },
      });
    }
  };

  useEffect(() => {
    if (getDashboardConfigurationLoading || cardDataLoading) {
      setLaoding(true);
    } else {
      setLaoding(false);
    }
  }, [getDashboardConfigurationLoading, cardDataLoading]);

  useEffect(() => {
    return () => {
      dispatch({
        type: GET_CARD_SUMMARY_EMPTY,
      });
    };
  }, []);

  const openCalendar = () => {
    if (flatpickrInstance.current) {
      flatpickrInstance.current.open();
    }
  };

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === 'Dashboard') {
      history.push('/v2/dashboard');
    } else if (title === 'Template Management') {
      history.push('/surge/templates');
    }
  };

  const updateURLParams = (data?: { value: string; label: string }, isSetTrue = true) => {
    const currentParams = queryString.parse(location.search);

    const updatedParams = {
      ...currentParams,
      sectionFilter: data?.value ?? '',
    };

    const newUrl = queryString.stringify(updatedParams);
    if (isSetTrue) setFilter({ startDate: '', endDate: '', timelineFilter: data });

    history.push({
      pathname: location.pathname,
      search: `?${newUrl}`,
    });
  };

  // Arrow Nav tabs
  const arrowNavToggle = tab => {
    if (arrowNavTab !== tab) {
      setarrowNavTab(tab);
    }
  };

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        {laoding && <Loader />}
        <div className="d-flex justify-content-between">
          <div className="d-flex gap-2">
            <BreadcrumbTrail
              title={getDashboardConfiguration?.modules?.[nextNavigation?.toString()]?.name}
              navigationby={breadcrumNavigationHandler}
              navigation={['Dashboard']}
            />
            <div style={{ borderLeft: '3px solid #405189', height: '28px' }}></div>
            <p className="mt-1 fw-semibold">
              {filter?.startDate && filter.endDate && (
                <>
                  {moment(filter.startDate).format('D MMM')} - {moment(filter.endDate).format('D MMM')}
                </>
              )}
            </p>
            <div className="mt-1">
              <i onClick={openCalendar} style={{ cursor: 'pointer' }} className="ri-pencil-fill"></i>
            </div>
            <input ref={inputRef} type="text" placeholder="Select date" style={{ display: 'none' }} />
          </div>
          <div className="d-flex gap-3">
            <div style={{ height: 40 }}>
              <Select
                options={bookingOptions}
                placeholder="Select Type"
                value={filter?.timelineFilter}
                styles={{
                  control: provided => ({
                    ...provided,
                    width: '200px', // Set custom width
                  }),
                }}
                onChange={data => {
                  updateURLParams(data);
                  // setFilterOfBarChart({ project: null, country: null });
                }}
              />
            </div>

            <button style={{ height: 37 }} className="btn btn-success d-flex align-items-center gap-1" onClick={() => fetchAllCards()}>
              <i className=" ri-refresh-line"></i>
              Refresh
            </button>
          </div>
        </div>

        {nextNavigation.toString() === 'airport_transfer_dashboard' && (
          <Nav pills className="nav nav-pills mb-3 fs-14" style={{ borderRadius: '40px', background: '#ACB6D8', width: '260px' }}>
            <NavItem>
              <NavLink
                style={{ cursor: 'pointer', padding: '8px 16px', margin: '10px', fontSize: '12px', borderRadius: '40px', fontWeight: '600' }}
                className={classNames({
                  'active-custom-nav': arrowNavTab === '1',
                })}
                onClick={() => {
                  arrowNavToggle('1');
                }}
              >
                Dashboard
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: 'pointer', padding: '8px 16px', margin: '10px', fontSize: '12px', borderRadius: '40px', fontWeight: '600' }}
                className={classNames({
                  'active-custom-nav': arrowNavTab === '2',
                })}
                onClick={() => {
                  arrowNavToggle('2');
                }}
              >
                Partner Wise
              </NavLink>
            </NavItem>
          </Nav>
        )}

        <TabContent activeTab={arrowNavTab}>
          <TabPane tabId="1" id="arrow-overview">
            {/* SLA Wise Bookings */}
            {slaBooking && (
              <Card style={{ borderRadius: '10px', marginBottom: '1rem' }}>
                <CardBody>
                  <div className="d-flex gap-2" style={{ alignItems: 'baseline', marginBottom: '10px' }}>
                    <p className="fs-20 fw-medium m-0">{slaBooking?.displayName}</p>
                    <p style={{ color: '#999999' }} className="fs-12 m-0">
                      {moment().format('dddd D, MMM hh:mm:ss')}
                    </p>
                  </div>

                  {/* Scrollable Container */}
                  <div className="sla-container">
                    <div className="sla-scroll">
                      {slaBooking?.cards.map((slaBooking, index) => (
                        <SLACard
                          key={index}
                          slaBooking={slaBooking}
                          cardData={cardData}
                          filter={filter}
                          nextNavigation={nextNavigation?.toString()}
                        />
                      ))}
                    </div>
                  </div>
                </CardBody>
              </Card>
            )}

            {/*  Status Wise Bookings */}
            {statusBooking && (
              <Card style={{ borderRadius: '10px' }}>
                <CardBody>
                  <div className="d-flex gap-2" style={{ alignItems: 'baseline' }}>
                    <p className="fs-20 fw-medium">{statusBooking?.displayName}</p>
                    <p style={{ color: '#999999' }} className="fs-12">
                      {moment().format('dddd D, MMM hh:mm:ss')}
                    </p>
                  </div>

                  {/* Scrollable Container */}
                  <div className="sla-container p-1">
                    <div className="status-scroll">
                      {statusBooking?.cards?.map((statusBooking, index: number) => (
                        <StatusCard
                          key={index}
                          statusBooking={statusBooking}
                          cardData={cardData}
                          filter={filter}
                          nextNavigation={nextNavigation?.toString()}
                        />
                      ))}
                    </div>
                  </div>
                </CardBody>
              </Card>
            )}

            {/*  Action Items On Bookings */}
            {actionItemBooking && (
              <Card style={{ borderRadius: '10px' }}>
                <CardBody>
                  <div className="d-flex gap-2" style={{ alignItems: 'baseline' }}>
                    <p className="fs-20 fw-medium">{actionItemBooking?.displayName}</p>
                    <p style={{ color: '#999999' }} className="fs-12">
                      {moment().format('dddd D, MMM hh:mm:ss')}
                    </p>
                  </div>

                  {/* Scrollable Container */}
                  <div className="sla-container p-1">
                    <div className="action-scroll">
                      {actionItemBooking?.cards.map((actionBooking, index: number) => (
                        <ActionBookingCard
                          key={index}
                          actionBooking={actionBooking}
                          cardData={cardData}
                          filter={filter}
                          nextNavigation={nextNavigation?.toString()}
                        />
                      ))}
                    </div>
                  </div>
                </CardBody>
              </Card>
            )}

            <Row>
              {charts?.donutChart && <DonutChart data={cardData?.[charts?.donutChart?.name]?.data?.data} title={charts?.donutChart?.displayName} />}

              {charts?.regionWiseChart && (
                <GeoChart data={cardData?.[charts?.regionWiseChart?.name]?.data?.data} title={charts?.regionWiseChart?.displayName} />
              )}

              {charts?.barChart && (
                <BarChart
                  data={cardData?.[charts?.barChart?.name]?.data?.data}
                  title={charts?.barChart?.displayName}
                  filter={filterOfBarChart}
                  setFilter={setFilterOfBarChart}
                />
              )}
            </Row>
          </TabPane>
          <TabPane tabId="2" id="arrow-profile">
            <Card>
              <CardHeader style={{ background: '#DCDCDC21', display: 'flex', justifyContent: 'flex-end' }}>
                <Select
                  options={vendorOptions}
                  placeholder="Select Partner"
                  value={selectedVendor}
                  onChange={data => {
                    setSelectedSelectedVendor(data);
                  }}
                  styles={{
                    control: provided => ({
                      ...provided,
                      width: '200px', // Set custom width
                      borderRadius: '5px !important',
                    }),
                  }}
                  isSearchable={false}
                />
              </CardHeader>
              <CardBody>
                {partnerBooking && (
                  <div className="partner-container">
                    <div className="partner-scroll">
                      {partnerBooking?.cards.map((statusBooking, index) => (
                        <StatusPartnerCard
                          key={index}
                          statusBooking={statusBooking}
                          cardData={cardData}
                          filter={filter}
                          nextNavigation={nextNavigation?.toString()}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </CardBody>
            </Card>
          </TabPane>
        </TabContent>
      </Container>
    </div>
  );
};

export default BookingDashboard;
